/*
 *   File :doughnut-bar.js
 *   Author : https://evoqins.com
 *   Description : Doughnut chart component
 *   Integrations : react-chartjs-2,chart.js
 *   Version : 1.0.0
*/

import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart, ArcElement } from 'chart.js';

Chart.register(ArcElement);

const DoughnutChart = (props) => {
    
    const DATA = {
        labels: props.labels,
        datasets: [{
            label: '',
            data: [...props.data],
            backgroundColor: props.colors,
            borderWidth: 0
        }]
    };

    const OPTIONS = {
        responsive: true,
        plugins: {
            title: {
                display: false,
            },
            legend: {
                display: false
            },
            tooltip: {
                enabled: true,
            }
        }
    };

    return (
        <div className='h-240 w-328px w-280px-res'>
            <Doughnut data={DATA} options={OPTIONS} />
        </div>
    )
}

export default DoughnutChart;
